import { LitElement, html, unsafeCSS, TemplateResult } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { createRef, Ref, ref } from 'lit/directives/ref.js';
import { classMap } from 'lit/directives/class-map.js';
import styles from './toast.scss';

const TOAST_DURATION = 3000;

@customElement('tiktok-cookie-banner-toast')
export class Toast extends LitElement {
  static override styles = unsafeCSS(styles);

  @property() text!: string;
  @property({
    attribute: 'text-id',
  })
  textId!: string;

  @state() visible = true;

  private timeoutId = -1;
  private wrapperRef: Ref<HTMLDivElement> = createRef();

  override willUpdate(changedProperties: Map<string, unknown>): void {
    if (changedProperties.has('textId')) {
      this.resetAutoFadeOut();
    }
  }

  protected override firstUpdated(): void {
    this.resetAutoFadeOut();
    this.wrapperRef.value?.addEventListener('transitionend', () => {
      if (!this.visible) {
        this.dispatchEvent(new Event('fadeOutComplete'));
      }
    });
  }

  private resetAutoFadeOut(): void {
    if (!this.text) {
      return;
    }
    clearTimeout(this.timeoutId);
    this.timeoutId = window.setTimeout(() => {
      this.visible = false;
    }, TOAST_DURATION);
  }

  override render(): TemplateResult {
    return html`
      <div
        ${ref(this.wrapperRef)}
        class=${classMap({
          'cookie-banner-toast': true,
          show: this.visible,
        })}
      >
        ${this.text}
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'tiktok-cookie-banner-toast': Toast;
  }
}
